var React = require('react');

function Person (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"person"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2}),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":3},React.createElement("g",{"id":"person","fill":"#000000"},React.createElement("path",{"d":"M10,12 C7.33,12 2,13.34 2,16 L2,18 L18,18 L18,16 C18,13.34 12.67,12 10,12 M10,10 C12.21,10 14,8.21 14,6 C14,3.79 12.21,2 10,2 C7.79,2 6,3.79 6,6 C6,8.21 7.79,10 10,10","id":"Page-1"})))]);
}

Person.defaultProps = {"width":"20px","height":"20px","viewBox":"0 0 20 20","version":"1.1"};

module.exports = Person;

Person.default = Person;



// WEBPACK FOOTER //
// ./src/icons/person.svg